import { LoanappService } from './../../services/loanapp.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-new-appointments',
  templateUrl: './new-appointments.component.html',
  styleUrls: ['./new-appointments.component.css'],
})
export class NewAppointmentsComponent implements OnInit {
  user: any;
  p: number = 1;
  itemsPerPage = 10;
  currentPage = 1;
  lApplications: Array<any> = [];
  dataRec: Boolean = false;
  dataToShow: Array<any> = [];
  appObj: any;
  filterWnameArr: Array<string> = [];
  formula: string = 'Formula 1';
  constructor(
    // public datepipe: DatePipe,
    private lservice: LoanappService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    let obj = { status: 'pending' };
    this.lservice.getLoanAppforCMAWithStatus(obj).subscribe((data) => {
      this.dataRec = true;
      if (data['success']) {
        this.lApplications = data['data'];
        this.dataToShow = data['data'];
        for (let i = 0; i < this.dataToShow.length; i++) {
          this.dataToShow[i]['tprice'] =
            this.dataToShow[i]['depositApp']['depositQty'] *
            this.dataToShow[i]['depositApp']['perUnitValue'];
          if (
            !this.isInArray(
              this.lApplications[i]['warehouseName'],
              this.filterWnameArr
            )
          ) {
            this.filterWnameArr.push(this.lApplications[i]['warehouseName']);
          }
        }
      } else {
        this.toastr.error('Something went wrong. Please try again.');
      }
    });
  }

  isInArray(value, array) {
    return array.indexOf(value) > -1;
  }

  rowclick(value) {
    this.appObj = value;
    window.location.href =
      '/loanapplicationdetails?id=' +
      value['_id'] +
      '&p=cma' +
      '&uId=' +
      value['user']['_id'];
  }

  onSearchChange(searchValue: string) {
    if (searchValue !== '') {
      this.dataToShow = this.filterItems(searchValue);
    } else {
      this.dataToShow = this.lApplications;
    }
  }

  filterItems(searchTerm) {
    return this.dataToShow.filter((item) =>
      Object.keys(item).some(
        (k) =>
          item[k] != null &&
          item[k].toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }

  onChangeWname(wname) {
    if (wname !== '') {
      this.dataToShow = this.filterWname(wname);
    } else {
      this.dataToShow = this.lApplications;
    }
  }
  filterWname(searchTerm) {
    let bArr = [];
    for (let u = 0; u < this.lApplications.length; u++) {
      if (
        this.lApplications[u].warehouseName.toLowerCase() ==
        searchTerm.toLowerCase()
      ) {
        bArr.push(this.lApplications[u]);
      }
    }
    return bArr;
  }

  onChangeStatus(state) {
    if (state !== '') {
      this.dataToShow = this.filterStatus(state);
    } else {
      this.dataToShow = this.lApplications;
    }
  }
  filterStatus(searchTerm) {
    console.log(searchTerm);
    let bArr = [];
    for (let u = 0; u < this.lApplications.length; u++) {
      if (
        this.lApplications[u].commodityName.toLowerCase() ==
        searchTerm.toLowerCase()
      ) {
        bArr.push(this.lApplications[u]);
      }
    }
    return bArr;
  }
  logout() {
    localStorage.clear();
    this.router.navigateByUrl('/login');
  }

  dateDiff(date) {
    if (date) {
      const todaysDate = new Date().getTime();
      const serverDate = new Date(date).getTime();
      const diffTime = Math.abs(serverDate - todaysDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    } else {
      return 'CMA not assigned';
    }
  }

  csvOptions = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalseparator: '.',
    showLabels: true,
    showTitle: true,
    title: 'New CMA appointments :',
    useBom: true,
    noDownload: false,
    headers: [
      'Holiday ID',
      'Holiday Date',
      'Holiday Comment',
      'Holiday Status',
    ],
  };
  downloadCSV() {
    new AngularCsv(
      this.dataToShow,
      'appointments-' + new Date().toDateString()
    );
    // new Angular5Csv(this.dataToShow, 'My Report');
  }
}
